<script lang="ts" setup>
import type { ImageType } from '~/graphql/misc';

const props = defineProps<{
    post: {
        title: string,
        uri: string,
        date: string,
        slug: string,
        tags: {
            nodes: {
                name: string
            }[]
        },
        categories: {
            nodes: {
                name: string
            }[]
        }
        id: string,
        featuredImage: ImageType
    }
}>();
</script>
<template>
<div 
    :key="post?.id"
    class="col-lg-4 col-md-6 col-12"
>
    <div class="article-card h-100 d-flex flex-column">
        <div class="article-image-container position-relative overflow-hidden">
            <a :href="`/insights/${post?.slug}`">
            <NuxtImg
                v-if="post?.featuredImage?.node?.mediaItemUrl"
                :src="post?.featuredImage?.node?.mediaItemUrl"
                :alt="post?.featuredImage?.node?.title"
                class="article-image w-100"
            />
            </a>
        </div>
        
        <div class="article-content pt-3 d-flex flex-column">
            <div class="article-meta d-flex flex-wrap align-items-start justify-content-between mb-3">
                <div class="col-9 d-flex flex-wrap">
                    <template v-for="(tag, index) in post?.categories?.nodes">
                        <span class="meta-item me-3">
                            <small class="text-primary">{{ tag.name}}</small>
                        </span>
                        <span v-if="index !== post?.categories?.nodes.length -1" class="meta-separator me-3 text-primary">•</span>
                    </template>
                </div>
                <div class="col-3 d-flex justify-content-end">
                    <span class="meta-item">
                        <small class="text-green-light">{{ new Date(post?.date).toLocaleDateString('en-GB') }}</small>
                    </span>
                </div>
            </div>

            <a class="article-title text-dark-2 flex-grow-1" :href="`/insights/${post?.slug}`">{{ post?.title }}</a>

            <div class="action-div d-flex mt-auto">
                <a class="btn btn-secondary rounded-pill mt-3 mb-2" :href="`/insights/${post?.slug}`">
                READ ARTICLE
                </a>
            </div>
        </div>
    </div>
</div>
</template>